import { Card } from './BmsCardPrimitives'
import ValueGrid from './ValueGrid'

const CellVoltagesCard = ({ cellVoltages }) => (
  <Card>
    <span className="text-sm font-medium text-[#252a34] flex items-center gap-1.5 mb-1">
      <span className="material-icons text-base text-[#616a79]">show_chart</span>
      Cell Voltages
      <span className="bg-[#e6f8e6] text-[#03791f] text-xs font-medium rounded-full px-2 py-0.5 ml-1">{cellVoltages.length}</span>
    </span>
    <ValueGrid
      items={cellVoltages}
      legend={[{ label: 'Min Voltage', color: '#0ca30c' }, { label: 'Max Voltage', color: '#d03b3b' }]}
    />
  </Card>
)

export default CellVoltagesCard
